<style lang="scss">
.calls {
}
</style>

<!-- eslint-disable -->
<template>
  <section>
    <div class="row">
      <div class="col-sm-6">
        <call-overview></call-overview>
        <basic-details></basic-details>
        <additional-visitors :show-add-btn="false"></additional-visitors>
      </div>
      <div class="col-sm-6">
        <visitor-details :visitor_user_id="call.visitor.user_id"></visitor-details>
      </div>
    </div>
  </section>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import BasicDetails from '@/views/calls/callDetails/sections/BasicDetails.vue';
import AdditionalVisitors from '@/views/calls/callDetails/sections/AdditionalVisitors';
import CallOverview from '@/views/calls/callDetails/sections/CallOverview.vue';
import VisitorDetails from '@/components/visitors/details/VisitorDetails.vue';

export default {
  name: 'CallDetailsRejected',
  components: {
    BasicDetails,
    AdditionalVisitors,
    CallOverview,
    VisitorDetails,
  },
  props: {},
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      call: state => state.callDetails.call,
      additionalVisitors: state => state.callDetails.additionalVisitors,
    }),
  },
  mounted() {

  },
  methods: {

  },
}
</script>
